import { DataMap } from '@grapecity/wijmo.grid'

import { ListItem } from '../utility/list-item'

// NOTE: Make sure this stays in sync with the server-side enum (PendingChangeOrderWorkType.cs).
export enum PendingChangeOrderWorkType {
    CriticalPath = 0,
    FutureWork = 1,
}

const labels: Record<PendingChangeOrderWorkType, string> = {
    [PendingChangeOrderWorkType.CriticalPath]: 'Critical Path',
    [PendingChangeOrderWorkType.FutureWork]: 'Future Work',
}

export function pendingChangeOrderWorkTypeDisplay(value: PendingChangeOrderWorkType | undefined): string {
    const v = value ?? PendingChangeOrderWorkType.CriticalPath
    return labels[v] ?? labels[PendingChangeOrderWorkType.CriticalPath]
}

/** List items for Wijmo combo boxes (value = enum, display = label). Order matches the enum values 0..n. */
export function createPendingChangeOrderWorkTypeListItems(): ListItem<PendingChangeOrderWorkType>[] {
    return [
        new ListItem<PendingChangeOrderWorkType>(
            PendingChangeOrderWorkType.CriticalPath,
            labels[PendingChangeOrderWorkType.CriticalPath],
        ),
        new ListItem<PendingChangeOrderWorkType>(
            PendingChangeOrderWorkType.FutureWork,
            labels[PendingChangeOrderWorkType.FutureWork],
        ),
    ]
}

/** DataMap for Wijmo grids (same key/display pairing as @see createPendingChangeOrderWorkTypeListItems). */
export function createPendingChangeOrderWorkTypeDataMap(): DataMap {
    return new DataMap(createPendingChangeOrderWorkTypeListItems(), 'value', 'display')
}
